import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { replaceLineBreaks } from 'shared/lib/helper-functions';

import CellShape from './CellShape';

export default class ValueViewer extends PureComponent {
  render() {
    const { value } = this.props;

    const valueWithoutLineBreaks = replaceLineBreaks(value);

    return <span className="value-viewer">{valueWithoutLineBreaks}</span>;
  }
}

ValueViewer.propTypes = {
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  cell: PropTypes.shape(CellShape),
  value: PropTypes.node.isRequired,
};
